module.exports = __webpack_public_path__ + "static/media/rolling04_3.59318162.png";